// OAuth Domain - Main Export
// Re-export all components, hooks, utils, and types

// Components
export { default as SocialSignInButton } from './components/social-signin-button'

// Hooks
export { useSocialSignIn } from './hooks/useSocialSignIn'

// Utils
export { kakao, line, fb, apple, google } from './utils/oauth-adapters'

// Types
export type { SignInTargetType, SignInAdaptor, UseSocialSignInConfig, UseSocialSignInReturn } from './types'
